// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"365":"css/app.6866","5830":"css/admin-app.6866"}[chunkId] + ".css";
};